<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.667 12.5H30.0003M11.667 20.8333H30.0003M33.3917 5H8.34821C6.62647 5 5.21777 6.35 5.21777 8V35L11.4786 29H33.3917C35.1134 29 36.5221 27.65 36.5221 26V8C36.5221 6.35 35.1134 5 33.3917 5Z" stroke="white" stroke-width="3"/>
</svg>
